import instanceJWT from "./apiJwt";
import type { GuidanceProgressMap, GuidanceProgress, GuidanceKind } from "../models/guidance/GuidanceTypes";

interface ApiResponse<T> {
  status: boolean;
  error: boolean;
  data: T;
}

function readSlot(data: GuidanceProgressMap, key: string): GuidanceProgress {
  return {
    step: data[key]?.["guidance-step"] ?? 1,
    paused: data[key]?.["guidance-paused"] === 1,
  };
}

export async function getGuidanceProgress(): Promise<Record<GuidanceKind, GuidanceProgress>> {
  const response = await instanceJWT.get<ApiResponse<GuidanceProgressMap>>("guidance");
  const data = response.data.data ?? {};

  return { work: readSlot(data, "eplex"), onboarding: readSlot(data, "onboarding") };
}

export async function saveGuidanceProgress(progress: Record<GuidanceKind, GuidanceProgress>): Promise<void> {
  const data: GuidanceProgressMap = {
    eplex: {
      "guidance-step": progress.work.step,
      "guidance-paused": progress.work.paused ? 1 : 0,
    },
    onboarding: {
      "guidance-step": progress.onboarding.step,
      "guidance-paused": progress.onboarding.paused ? 1 : 0,
    },
  };
  await instanceJWT.put("guidance", data);
}
